/* rc4064f — BLACK FRIDAY: doplnění skrytých tierových kódů k veřejnému BF15 (vzor pika-pikadays-kosik, rc3430).
 * Spouští se jen když je v košíku uplatněný kód rodiny BF (BF15, BF20, BF20A …). Nikdy nemaže cizí kódy zákazníka; maže jen ty,
 * které sám doplnil a už nejsou potřeba. Nejvýš 5 kódů celkem. */
(function (root) {
  var RODINA = /^BF(\d{2})([A-J])?$/
  var MAX_KODU = 5
  var STROP = 15
  function pctKodu(k) { var m = RODINA.exec(String(k || '').toUpperCase()); return m ? +m[1] : 0 }

  /* Čistý výběr (bez sítě): polozky [{variant_id, cena}], kodVar {variant_id: kód}, pouzite [kódy v košíku], auto [kódy, které jsme doplnili].
   * Vrací { kody: nový seznam | null (beze změny), auto: [...] }. */
  function vyber(polozky, kodVar, pouzite, auto) {
    pouzite = (pouzite || []).map(function (k) { return String(k).toUpperCase() })
    auto = (auto || []).filter(function (k) { return pouzite.indexOf(k) >= 0 })
    if (!pouzite.some(function (k) { return RODINA.test(k) })) return { kody: null, auto: [] }
    var navic = {}
    polozky.forEach(function (it) {
      var k = kodVar[it.variant_id]
      var p = pctKodu(k)
      if (!k || p <= STROP) return
      navic[k] = (navic[k] || 0) + (it.cena || 0) * (p - STROP) / 100
    })
    var zakaznik = pouzite.filter(function (k) { return auto.indexOf(k) < 0 })
    var mista = Math.max(0, MAX_KODU - zakaznik.length)
    var kandidati = Object.keys(navic).filter(function (k) { return zakaznik.indexOf(k) < 0 })
      .sort(function (a, b) { return navic[b] - navic[a] || (a < b ? -1 : 1) })
      .slice(0, mista)
    var nove = zakaznik.concat(kandidati)
    var stejne = nove.length === pouzite.length && nove.every(function (k) { return pouzite.indexOf(k) >= 0 })
    return { kody: stejne ? null : nove, auto: kandidati }
  }
  root.__pikaBfVyber = vyber
  if (typeof document === 'undefined' || typeof fetch === 'undefined') return
  if (root.__pikaBfK) { try { root.__pikaBfK.scan() } catch (e) {} return }

  var KLIC = 'pikaBfAuto', timer = null, bezi = false, vlastni = 0, pokusy = {}
  root.__pikaBfK = { scan: function () { naplanuj(150) } }
  function ulozeno() { try { return JSON.parse(sessionStorage.getItem(KLIC) || '[]') || [] } catch (e) { return [] } }
  function uloz(a) { try { sessionStorage.setItem(KLIC, JSON.stringify(a)) } catch (e) {} }
  function sekce() {
    return fetch('/?sections=pika-bfk&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null })
      .then(function (j) {
        var h = j && j['pika-bfk']; if (!h) return null
        var m = /data-pika-bfk[^>]*>([\s\S]*?)<\/div>/.exec(h); if (!m) return null
        try { return JSON.parse(m[1].replace(/&quot;/g, '"').replace(/&amp;/g, '&')) } catch (e) { return null }
      }).catch(function () { return null })
  }
  function kosik() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null }).catch(function () { return null })
  }
  function obnov() {
    if (typeof root.__pikaObnovKosik === 'function') { try { root.__pikaObnovKosik(); return } catch (e) {} }
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })) } catch (e) {}
  }
  function naplanuj(ms) { clearTimeout(timer); timer = setTimeout(spust, ms || 300) }
  function spust() {
    if (bezi || vlastni > 0) { naplanuj(400); return }
    bezi = true
    kosik().then(function (c) {
      if (!c || !c.items || !c.items.length) { uloz([]); return null }
      var pouzite = (c.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase() }).filter(Boolean)
      if (!pouzite.some(function (k) { return RODINA.test(k) })) return null
      return sekce().then(function (d) { return d ? { c: c, d: d, pouzite: pouzite } : null })
    }).then(function (x) {
      if (!x) return
      var kodVar = {}
      ;(x.d.i || []).forEach(function (r) { kodVar[r[0]] = String(r[1]).toUpperCase() })
      var polozky = x.c.items.map(function (it) { return { variant_id: it.variant_id, cena: (it.original_line_price != null ? it.original_line_price : it.line_price) || 0 } })
      var v = vyber(polozky, kodVar, x.pouzite, ulozeno())
      uloz(v.auto)
      if (!v.kody) return
      var sig = v.kody.join(',') + '|' + x.pouzite.join(',')
      pokusy[sig] = (pokusy[sig] || 0) + 1
      if (pokusy[sig] > 2) return /* pojistka proti smyčce */
      vlastni++
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ discount: v.kody.join(',') }) })
        .then(function () { vlastni--; obnov(); setTimeout(function () { naplanuj(200) }, 1200) }, function () { vlastni-- })
    }).catch(function () {}).then(function () { bezi = false })
  }
  ;['cart:change', 'cart:refresh', 'cart:updated'].forEach(function (n) { document.addEventListener(n, function () { naplanuj(450) }) })
  try {
    var f0 = root.fetch
    root.fetch = function (u) {
      var url = typeof u === 'string' ? u : (u && u.url) || ''
      var p = f0.apply(this, arguments)
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)|\/discount\//.test(url) && !/pika-bfk/.test(url)) p.then(function () { naplanuj(500) }, function () {})
      return p
    }
  } catch (e) {}
  root.addEventListener('pageshow', function () { naplanuj(300) })
  if ((root.__pikaBfPolozek || 0) > 0) naplanuj(900)
})(typeof window !== 'undefined' ? window : globalThis)
